import type React from 'react';

export interface ChevronRightIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({
	width = 6,
	height = 10,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Chevron Right Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 6 10"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			d="M1 1L5 5L1 9"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default ChevronRightIcon;
